import { get as _get } from 'lodash';

export const getPolicySource = (policyNumber: string, policies: any) => {
  let policySource = '';
  policies &&
    policies.find((policy: any) => {
      if (_get(policy, 'policyNumber') === policyNumber) {
        // Return matched Policy Source
        policySource = _get(policy, 'policySource');
      }
    });
  return policySource.toUpperCase();
};
